export function productAside() {
    const
        expandBtn = $("a.expand-btn"),
        sidebar = $(".sidebar");

    expandBtn.on("click", function (event) {
        event.preventDefault();
        setTimeout(() => {
            let
                $this = $(this),
                href = $this.attr("href"),
                otherSidebarContent = $(href),
                isOtherContent = otherSidebarContent.length;

            $(".aside-content").removeClass("active");

            if ($this.parents(".dropdown").hasClass("active")) {
                sidebar.addClass("hide-content");

                if (isOtherContent) {
                    otherSidebarContent.css("padding-top", 0);
                    otherSidebarContent.addClass("active");

                    let
                        linkTop = parseInt($this.offset().top),
                        sidebarContentTop = parseInt(otherSidebarContent.offset().top);

                    if (window.innerWidth > 767 && sidebarContentTop < linkTop) {
                        otherSidebarContent.css("padding-top", (linkTop - sidebarContentTop) + "px");
                    }
                }

            } else {

                if (isOtherContent) {
                    otherSidebarContent.removeClass("active");
                }

                sidebar.removeClass("hide-content");
            }
        }, 700);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/productAside.js